import { useInfiniteQuery } from '@tanstack/react-query';
import { workLogKeys } from '@/entities/work-log';
import { fetchWorkLogs } from '../api';

/** 지난 일지 한 묶음 크기. */
export const WORK_LOG_HISTORY_PAGE_SIZE = 20;

/**
 * 지난 일지를 최신순으로 이어 읽는다. 다음 묶음은 지금까지 받은 가장 오래된 날짜보다 앞선 것이다.
 * 목록 API 는 기본 50건만 돌려줘서, 커서 없이 부르면 일지가 50건 넘는 사람은 거기서 끊긴다.
 */
export function useWorkLogHistory(userId: string | undefined) {
  return useInfiniteQuery({
    queryKey: workLogKeys.history(userId),
    queryFn: ({ pageParam }) =>
      fetchWorkLogs(
        pageParam
          ? { take: WORK_LOG_HISTORY_PAGE_SIZE, before: pageParam }
          : { take: WORK_LOG_HISTORY_PAGE_SIZE }
      ),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) =>
      lastPage.length < WORK_LOG_HISTORY_PAGE_SIZE ? undefined : lastPage.at(-1)?.logDate,
    enabled: !!userId,
    staleTime: 30_000,
  });
}
